import React, { FC } from 'react';

import ReadingsDetailPage from "@/components/readings/ReadingsDetailPage";
import { Medium } from "@/constants/mediums";

const WasteReadingsDetailPage: FC = () => {
  return <ReadingsDetailPage medium={Medium.waste} />;
};

export default WasteReadingsDetailPage;
